"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tinycolor = require("@ctrl/tinycolor");
var _react = _interopRequireDefault(require("react"));
var _getColorBgImg = _interopRequireDefault(require("../utils/getColorBgImg"));
var _getDesignToken2 = _interopRequireDefault(require("../utils/getDesignToken"));
var TokenPreview = function TokenPreview(_ref) {
  var theme = _ref.theme,
    tokenName = _ref.tokenName,
    type = _ref.type;
  var _getDesignToken = (0, _getDesignToken2.default)(theme),
    colorBgContainer = _getDesignToken.colorBgContainer;
  var isDark = new _tinycolor.TinyColor(colorBgContainer).getBrightness() < 50;
  if (type === 'Color') {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px"),
        width: '100%',
        height: '100%',
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '100%',
        width: '100%',
        backgroundColor: (0, _getDesignToken2.default)(theme)[tokenName],
        transition: 'background-color 0.2s'
      }
    }));
  }
  if (type === 'FontSize') {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px"),
        fontSize: (0, _getDesignToken2.default)(theme)[tokenName],
        fontWeight: 700
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "Aa"));
  }
  if (type === 'LineHeight') {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        overflow: 'hidden',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px")
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontSize: (0, _getDesignToken2.default)(theme)[tokenName.replace('lineHeight', 'fontSize')],
        lineHeight: (0, _getDesignToken2.default)(theme)[tokenName],
        background: '#fff2f0',
        paddingInline: 8
      }
    }, "Aa"));
  }
  if (type === 'Margin') {
    var margin = (0, _getDesignToken2.default)(theme)[tokenName];
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px")
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        background: '#fff1b8',
        transform: 'translate(10%, 10%) scale(0.8)'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginLeft: margin,
        marginTop: margin,
        width: "calc(100% - ".concat(margin, "px)"),
        height: "calc(100% - ".concat(margin, "px)"),
        background: '#bae0ff'
      }
    })));
  }
  if (type === 'Padding') {
    var padding = (0, _getDesignToken2.default)(theme)[tokenName];
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px")
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        background: '#d9f7be',
        transform: 'translate(10%, 10%) scale(0.8)',
        paddingLeft: padding,
        paddingTop: padding
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: "100%",
        height: "100%",
        background: '#bae0ff'
      }
    })));
  }
  if (type === 'BorderRadius') {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px")
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        transform: 'translate(30%, 30%)',
        border: '2px solid rgba(0,0,0,0.45)',
        background: '#fff',
        borderRadius: (0, _getDesignToken2.default)(theme)[tokenName]
      }
    }));
  }
  if (type === 'BoxShadow') {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: "".concat((0, _getColorBgImg.default)(isDark), " 0% 0% / 28px")
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '60%',
        height: '50%',
        borderRadius: 6,
        background: '#fff',
        border: '1px solid #d9d9d9',
        boxShadow: (0, _getDesignToken2.default)(theme)[tokenName]
      }
    }));
  }
  return null;
};
var _default = exports.default = TokenPreview;